function goToNext(): void {
  const activeItems = document.querySelectorAll('.active-thumb');
  const active = activeItems[activeItems.length - 1];
  const nextItem = active?.parentElement?.nextElementSibling;

  nextItem?.querySelector('a')?.click();
}

function goToPrev(): void {
  const activeItems = document.querySelectorAll('.active-thumb');
  const active = activeItems[activeItems.length - 1];
  const prevItem = active?.parentElement?.previousElementSibling;

  prevItem?.querySelector('a')?.click();
}

export function initProductImagesNavigation(): void {
  const prev = document.getElementById('prev');
  const next = document.getElementById('next');
  next?.addEventListener('click', goToNext);
  prev?.addEventListener('click', goToPrev);

  jQuery('#thumbnails-list').on('afterChange', function () {
    const anchor = document.querySelector(
      '.slick-slide.slick-current.slick-active a'
    );

    if (anchor instanceof HTMLAnchorElement) {
      anchor.click();
    }
  });
}
